"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _require = require("./utils"),
  ConfigurationError = _require.ConfigurationError;
var _require2 = require("./constants/loggingLevels"),
  DEBUG = _require2.DEBUG,
  INFO = _require2.INFO,
  WARNING = _require2.WARNING,
  ERROR = _require2.ERROR,
  JSERROR = _require2.JSERROR,
  ADD_ATTRIBUTE = _require2.ADD_ATTRIBUTE,
  REMOVE_ATTRIBUTE = _require2.REMOVE_ATTRIBUTE;
var IAdapter = require("./interfaces/IAdapter");
var ILogger = require("./interfaces/ILogger");
var Logger = /*#__PURE__*/function (_ILogger) {
  function Logger() {
    var _this;
    (0, _classCallCheck2["default"])(this, Logger);
    _this = _callSuper(this, Logger);
    (0, _defineProperty2["default"])(_this, "adapterIds", null);
    (0, _defineProperty2["default"])(_this, "broadcastExceptSelf", function (selfId) {
      return function () {
        var _this2;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return (_this2 = _this)._broadcast.apply(_this2, [Array.from(_this.adapterIds).filter(function (id) {
          return id !== selfId;
        })].concat(args));
      };
    });
    _this._onEvent = _this.on.bind(_this);
    _this.adapterIds = new Set();
    return _this;
  }
  (0, _inherits2["default"])(Logger, _ILogger);
  return (0, _createClass2["default"])(Logger, [{
    key: "_broadcast",
    value: function _broadcast(targets, channel) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }
      var _iterator = _createForOfIteratorHelper(targets),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var target = _step.value;
          this.emit.apply(this, ["".concat(target, "-").concat(channel)].concat(args));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return this;
    }
  }, {
    key: "broadcast",
    value: function broadcast(channel) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      this._broadcast.apply(this, [this.adapterIds, channel].concat(args));
      return this;
    }
  }, {
    key: "addAttribute",
    value: function addAttribute(key, value) {
      this.broadcast(ADD_ATTRIBUTE, key, value);
      return this;
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(key) {
      this.broadcast(REMOVE_ATTRIBUTE, key);
      return this;
    }
  }, {
    key: "debug",
    value: function debug() {
      this.broadcast.apply(this, [DEBUG].concat(Array.prototype.slice.call(arguments)));
    }
  }, {
    key: "info",
    value: function info() {
      this.broadcast.apply(this, [INFO].concat(Array.prototype.slice.call(arguments)));
    }
  }, {
    key: "log",
    value: function log() {
      this.info.apply(this, arguments);
    }
  }, {
    key: "warn",
    value: function warn() {
      this.broadcast.apply(this, [WARNING].concat(Array.prototype.slice.call(arguments)));
    }
  }, {
    key: "error",
    value: function error() {
      this.broadcast.apply(this, [ERROR].concat(Array.prototype.slice.call(arguments)));
    }
  }, {
    key: "jsError",
    value: function jsError() {
      this.broadcast.apply(this, [JSERROR].concat(Array.prototype.slice.call(arguments)));
    }
  }, {
    key: "attach",
    value: function attach(adapter) {
      var _this3 = this;
      if (adapter instanceof IAdapter !== true) {
        throw new ConfigurationError("The provided object is not an adapter");
      }
      try {
        var key = adapter.key;
        if (!key) {
          throw new Error("Adapters need to have a defined key");
        }
        var boundOnEvent = function boundOnEvent() {
          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }
          var channel = args[0],
            rest = args.slice(1);
          var namespacedChannel = "".concat(key, "-").concat(channel);
          return _this3._onEvent.apply(_this3, [namespacedChannel].concat((0, _toConsumableArray2["default"])(rest)));
        };
        this.adapterIds.add(key);
        adapter.initialize(this.broadcastExceptSelf(key).bind(this));
        adapter.listen(boundOnEvent);
        return this;
      } catch (err) {
        var _adapter$name;
        throw new Error("An error has occurred when attempting to connect to adapter ".concat((_adapter$name = adapter === null || adapter === void 0 ? void 0 : adapter.name) !== null && _adapter$name !== void 0 ? _adapter$name : "unknown", ": ").concat(err));
      }
    }
  }]);
}(ILogger);
module.exports = Logger;